import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en'
import ar from './ar'
import ckb from './ckb'

export const LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' as const },
  { code: 'ar', label: 'العربية', dir: 'rtl' as const },
  { code: 'ckb', label: 'کوردی', dir: 'rtl' as const },
] as const

export type LanguageCode = (typeof LANGUAGES)[number]['code']

export function getLanguageDir(code: string): 'ltr' | 'rtl' {
  const lang = LANGUAGES.find((l) => l.code === code)
  return lang?.dir ?? 'ltr'
}

export function isRTL(code: string): boolean {
  return getLanguageDir(code) === 'rtl'
}

const savedLang = localStorage.getItem('omnitrace-lang') ?? 'en'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    ckb: { translation: ckb },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
